import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Redux States
import { CO_GET_SUPPLIERNAME_LISTING } from "./actionTypes"

import { coSupplierNameListingSuccess, coSupplierNameListingFail } from "./actions"

//Include Both Helper File with needed methods
import { coSupplierNameListingApi } from "../../../helpers/fakebackend_helper"

function* coGetSupplierNameListing() {
  try {
    const response = yield call(coSupplierNameListingApi)
    if (!response.results.supplier_names) {
      yield put(coSupplierNameListingFail(error))
    }
    yield put(coSupplierNameListingSuccess(response.results.supplier_names))
  } catch (error) {
    yield put(coSupplierNameListingFail(error))
  }
}

function* coSupplierNameSaga() {
  yield takeEvery(CO_GET_SUPPLIERNAME_LISTING, coGetSupplierNameListing)
}
export default coSupplierNameSaga
